import React from 'react';

// Onboarding screens
import SignUpLinkBank from './SignUpLinkBank';
import SignUpESign from './SignUpESign';
import SignUpAutoStash from './SignUpAutoStash';

// Retire screens
import SignUpTaxIncomeStatus from './retire/SignUpTaxIncomeStatus';
import SignUpRetireHouseholdIncome from './retire/SignUpRetireHouseholdIncome';
import SignUpRetireIRAChooser from './retire/SignUpRetireIRAChooser';
import SignUpRetireCompleteAddOn from './retire/SignUpRetireCompleteAddOn';

// Invest add-on screens
import SignUpInvestValueProp from './invest/SignUpInvestValueProp';
import SignUpInvestEsig from './invest/SignUpInvestEsig';
import SignUpInvestCompleteAddOn from './invest/SignUpInvestCompleteAddOn';

// Bank screens
import DebitSignUpTransferFunds from './bank/DebitSignUpTransferFunds';
import DebitSignUpConfirmAddressScreen from './bank/DebitSignUpConfirmAddressScreen';
import DebitSignUpConfirmInfoScreen from './bank/DebitSignUpConfirmInfoScreen';
import DebitSignUpCreateAccount from './bank/DebitSignUpCreateAccount';

export const SignUpScreens = {
	// Onboarding
	'link-bank': {
		path: 'link-bank',
		component: SignUpLinkBank,
	},
	'e-sign': {
		path: 'e-sign',
		component: SignUpESign,
	},
	'auto-stash': {
		path: 'auto-stash',
		component: SignUpAutoStash,
	},

	// Retire onboarding
	'tax-income-status': {
		path: 'tax-income-status',
		component: SignUpTaxIncomeStatus,
	},
	'retire-income': {
		path: 'retire-income',
		component: SignUpRetireHouseholdIncome,
	},
	'retire-ira-chooser': {
		path: 'retire-ira-chooser',
		component: SignUpRetireIRAChooser,
		isMilestone: true,
		milestoneName: 'Personal info',
	},
	'retire-complete-addon': {
		path: 'retire-complete-addon',
		component: SignUpRetireCompleteAddOn,
		isMilestone: true,
		milestoneName: 'Complete',
	},

	// Invest add-on
	'invest-addon': {
		path: 'invest-addon',
		component: SignUpInvestValueProp,
		isMilestone: true,
	},
	'invest-esign': {
		path: 'invest-esign',
		component: SignUpInvestEsig,
		isMilestone: true,
	},
	'invest-complete-addon': {
		path: 'invest-complete-addon',
		component: SignUpInvestCompleteAddOn,
		isMilestone: true,
		milestoneName: 'Complete',
	},

	// Debit onboarding
	'bank/confirm-address': {
		path: 'confirm-address',
		component: DebitSignUpConfirmAddressScreen,
	},
	'bank/create-account': {
		path: 'create-account',
		component: DebitSignUpCreateAccount,
		isMilestone: true,
		milestoneName: 'Confirm info',
	},
	'bank/account-completed': {
		path: 'account-completed',
		component: () => <div></div>,
		isMilestone: true,
		milestoneName: 'Create debit account',
	},
	'bank/confirm-info': {
		path: 'confirm-info',
		component: DebitSignUpConfirmInfoScreen,
	},
	'bank/debit-fund': {
		path: 'debit-fund',
		component: DebitSignUpTransferFunds,
	},
	'bank/fund-completed': {
		path: 'fund-completed',
		isMilestone: true,
		milestoneName: 'Funding',
	},
};

export default SignUpScreens;
